import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vceppzx3jv: FaireBrandEntity = {
  token: "b_vceppzx3jv",
  type: "brand",
  name: "The Dutch Oven Smokehouse",
  avatarUrl:
    "https://cdn.faire.com/fastly/1b75fc228b5b637ce463c602bfd0e3814af741e4f2658657d7fd7aa30db78190.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ddfd9cef9ec4a95940766d13cfce1080327bbcd5a09a6c2cd2f48db148b23ec5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1b75fc228b5b637ce463c602bfd0e3814af741e4f2658657d7fd7aa30db78190.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ddfd9cef9ec4a95940766d13cfce1080327bbcd5a09a6c2cd2f48db148b23ec5.jpeg",
  location: "Haxtun, CO, USA",
  minimumOrderDollars: 0,
  rating: 4.8,
  reviewCount: 6,
  isTopShop: true,
  isInsider: true,
  description:
    "Our brand originated on the plains of Eastern Colorado in the heart of farming and ranching country, rooted deep in Western agricultural traditions. Our goal is to impart and incorporate these heritages and traditions into our products and flavors. Our flavors give respect to the regions they originated from yet we are creative in designing new flavors to add intrigue to our products.  'Old West flavors set in the New Frontier'.  The Dutch Oven symbol represents the old frontier style of cooking; slow, methodical and authentic. Our motto is to slow food down and slow life down. Quiet your heart and enjoy the company of others. Grab a chair by the fire, sit back and enjoy our company!",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:48.671Z",
    importedBy: "entity-db-cli",
  },
};
